/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown> }} Support_Validation_Message_MinInputs */



/**
* | output |
* | --- |
* | "Please use at least {min} characters - one full sentence helps our support team reproduce the problem." |
*
* @param {Support_Validation_Message_MinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const support_validation_message_min = /** @type {((inputs: Support_Validation_Message_MinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Validation_Message_MinInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bitte nutze mindestens ${i?.min} Zeichen - ein vollständiger Satz hilft unserem Support-Team, das Problem nachzustellen.`)
	return /** @type {LocalizedString} */ (`Please use at least ${i?.min} characters - one full sentence helps our support team reproduce the problem.`)
});